import {
  BrowserRouter as Router,
  Routes,
  Route,
} from 'react-router-dom';

import Home from './pages/Home';
import About from './pages/About';
import Footer from './Footer'
import Header from './Header'
import Contact from './pages/Contact';
import Services from './pages/Services';
import ServicesLayout from './pages/ServicesLayout';
import WebDesign from './pages/WebDesign';
import ITServices from './pages/ITServices';
import MobileApps from './pages/MobileApps';
import ScrollToTop from './pages/ScrollToTop';
function App() {
  return (
    <Router>
      <ScrollToTop />
      <Header />
      <div className="dark:bg-gray-900 mx-auto pt-4">
        {/* <Header /> */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/services" element={<ServicesLayout />}>
            <Route index element={<Services />} />
            <Route path="web-design" element={<WebDesign />} />
            <Route path="mobile" element={<MobileApps />} />
            <Route path="IT" element={<ITServices />} />
          </Route>

        </Routes>
        {/* <Footer /> */}
      </div>
      <Footer />
    </Router>

  );
}

export default App;
